export default "__VITE_ASSET__CsludfrK__"